module.exports = __webpack_public_path__ + "img/ce8437b.jpg";